import { useI18n } from 'vue-i18n';
import Banner from 'presentation/Banner/Banner.vue';
import BaseMoney from 'presentation/components/BaseMoney/BaseMoney.vue';
import { useRouter } from 'vue-router';
import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';

export default {
  name: 'Home',
  components: { Banner, BaseMoney, VueperSlides, VueperSlide},

  setup() {
    const router = useRouter();
    if (window.innerWidth < 990) {
      router.replace({
        name: 'products',
        params: { categorySlug: 'all' },
      });
    }
    const { t } = useI18n();
    return {
      t,
    };
  },
  methods:{
   getPosts(){
    fetch('https://sierra-middleware.vercel.app/graphql',{
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer KZ9hUHRABRunHwB_CJGbH-RTr1zDSo5L`, // notice the Bearer before your token,
        'origin' :' ',
        'referer' : 'https://sierra-frontend-ui.vercel.app'
        },
      
      body: JSON.stringify({
        query :`{
          getHomePageData {
            header {
              sys {
                id
                contentType {
                  sys {
                    id
                    __typename
                  }
                  __typename
                }
                __typename
              }
              fields {
                categories {
                  categories {
                    results {
                      name
                      id
                      externalId
                      slug
                      orderHint
                      children {
                        id
                        name
                        externalId
                        slug
                        orderHint
                        children {
                          id
                          externalId
                          name
                          slug
                          orderHint
                          __typename
                        }
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                isCategoryDataEnabled
                websiteLogo {
                  sys {
                    id
                    contentType {
                      sys {
                        id
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  fields {
                    url
                    image {
                      fields {
                        title
                        file {
                          fileName
                          url
                          contentType
                          __typename
                        }
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                topHeader {
                  sys {
                    id
                    contentType {
                      sys {
                        id
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  fields {
                    helpLink {
                      sys {
                        id
                        contentType {
                          sys {
                            id
                            __typename
                          }
                          __typename
                        }
                        __typename
                      }
                      fields {
                        text
                        url
                        __typename
                      }
                      __typename
                    }
                    storeLink {
                      sys {
                        id
                        contentType {
                          sys {
                            id
                            __typename
                          }
                          __typename
                        }
                        __typename
                      }
                      fields {
                        text
                        url
                        __typename
                      }
                      __typename
                    }
                    language {
                      sys {
                        id
                        contentType {
                          sys {
                            id
                            __typename
                          }
                          __typename
                        }
                        __typename
                      }
                      fields {
                        title
                        listItem {
                          fields {
                            text
                            __typename
                          }
                          __typename
                        }
                        __typename
                      }
                      __typename
                    }
                    location {
                      sys {
                        id
                        contentType {
                          sys {
                            id
                            __typename
                          }
                          __typename
                        }
                        __typename
                      }
                      fields {
                        title
                        listItem {
                          fields {
                            text
                            url
                            __typename
                          }
                          __typename
                        }
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                searchLink {
                  sys {
                    id
                    contentType {
                      sys {
                        id
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  fields {
                    text
                    __typename
                  }
                  __typename
                }
                signInLink {
                  sys {
                    id
                    contentType {
                      sys {
                        id
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  fields {
                    iconClass
                    text
                    url
                    __typename
                  }
                  __typename
                }
                cartLink {
                  sys {
                    id
                    contentType {
                      sys {
                        id
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  fields {
                    text
                    __typename
                  }
                  __typename
                }
                shoppingListLink {
                  sys {
                    id
                    contentType {
                      sys {
                        id
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  fields {
                    text
                    url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            image_with_text_slider {
              fields {
                imageText
                sliderImage {
                  fields {
                    title
                    file {
                      fileName
                      url
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                __typename
              }
              sys {
                id
                __typename
              }
              __typename
            }
            home_service_gallery_view {
              fields {
                title
                box {
                  fields {
                    text
                    image {
                      fields {
                        title
                        file {
                          url
                          fileName
                          __typename
                        }
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  sys {
                    id
                    contentType {
                      sys {
                        id
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                __typename
              }
              sys {
                id
                contentType {
                  sys {
                    id
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            home_service_gallery_view2 {
              fields {
                title
                box {
                  fields {
                    text
                    image {
                      fields {
                        title
                        file {
                          url
                          fileName
                          __typename
                        }
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  sys {
                    id
                    contentType {
                      sys {
                        id
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                __typename
              }
              sys {
                id
                contentType {
                  sys {
                    id
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            service_card {
              fields {
                description
                iconClass
                title
                __typename
              }
              sys {
                id
                contentType {
                  sys {
                    id
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            footer {
              sys {
                id
                contentType {
                  sys {
                    id
                    linkType
                    __typename
                  }
                  __typename
                }
                __typename
              }
              fields {
                text
                link {
                  sys {
                    contentType {
                      sys {
                        id
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  fields {
                    text
                    url
                    __typename
                  }
                  __typename
                }
                logo {
                  sys {
                    contentType {
                      sys {
                        id
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  fields {
                    url
                    image {
                      fields {
                        title
                        file {
                          contentType
                          fileName
                          url
                          __typename
                        }
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                navLink {
                  sys {
                    contentType {
                      sys {
                        id
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  fields {
                    text
                    url
                    __typename
                  }
                  __typename
                }
                title
                submiText
                inputPlaceholder
                __typename
              }
              __typename
            }
            __typename
          }
        }
        `
      })
    })
      .then(response => response.json())
      .then((data) =>{

      console.log(data);
      this.component = data;
      this.componentList = data.data.getHomePageData.home_service_gallery_view;
      this.image_with_text_slider = data.data.getHomePageData.image_with_text_slider;
      console.log(this.image_with_text_slider);
      console.log("imagewithtextslider"+this.image_with_text_slider);
      console.log(this.componentList);
      } )
     
      
   }
  },
  mounted(){
    this.getPosts()
  },
  data() {
    return {
      component: {},
      componentList: {} ,
      document,
      getHomePageData: null,
      isGraphQlReqDone: false,
      slides: [
        {
          title: 'Slide 1',
          content: {
            bgImage: 'sbanner1.png',
            h3Message: 'midSeasonSale',
            h1Message: 'up50',
            bttnText: 'shopNow',
          },
        },
        {
          title: 'Slide 2',
          content: {
            bgImage: 'sbanner2.png',
            h3Message: 'checkout',
            h1Message: 'newCollection',
            bttnText: 'shopNow',
          },
        },
        {
          title: 'Slide 3',
          content: {
            bgImage: 'sbanner3.png',
            h3Message: 'checkout',
            h1Message: 'newCollection',
            bttnText: 'shopNow',
          },
        },
      ]
    };
  },
};
